<div class="container-fluid">
  <div class="row" style=" margin-top: 1rem;padding-left:2rem;">
    <div class=" col-xl-4 col-lg-4 col-md-8 col-sm-6 col-xs-4 " id="logos">
      <img src="./assets/images/HSRlogo.png" class="hsrLogo" alt="">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-12 col-sm-6 col-xs-8">
      <div class="row">
        <div class="col-lg-8 col-ms-4 col-sm-4">
        </div>
        <div class="col-lg-4 col-ms-4 col-sm-8">
          <div class="container dropdown" [matMenuTriggerFor]="menu">
            <button class="fullnameLogo" type="button">
                {{shortName}}
              </button>
              <span class="fullname">{{fullname}}</span>
              <div class="down-icon">
                <img src="./assets/images/down-icon.svg" alt="">
              </div>
          </div>
          <mat-menu #menu="matMenu" xPosition="before">
            <button mat-menu-item (click)="logout()">
              <span>Logout</span>
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <nav class="navbar navbar-expand-lg" id="appNav">
      <div class="container-fluid">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#collapsibleNavbar">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="collapsibleNavbar">
          <ul class="navbar-nav">

            <ng-container *ngIf="isLoggedIn && isAuthorized">
              <li class="nav-item" [routerLinkActive]="['active']" routerLink="/home" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="nav-link">Home</a>
              </li>
              <li class="nav-item" [routerLinkActive]="['active']" routerLink="/search-for-students" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="nav-link">Search for Student</a>
              </li>
              <li class="nav-item" [routerLinkActive]="['active']" routerLink="/claims" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="nav-link">Claims</a>
              </li>
              <ng-container *ngIf="login.userRole=='Admin'||login.isRoster">
                <li class="nav-item" [routerLinkActive]="['active']" routerLink="/roster" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                  <a class="nav-link">Roster</a>
                </li>
              </ng-container>
              <ng-container *ngIf="login.userRole=='Admin'||login.userRole=='District'">
                <li class="nav-item" [routerLinkActive]="['active']" routerLink="/admin" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                  <a class="nav-link">Admin</a>
                </li>
              </ng-container>
              <ng-container *ngIf="login.userRole=='Admin'||login.isRoster">
                <li class="nav-item" [routerLinkActive]="['active']" routerLink="/reports" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                  <a class="nav-link">Reports</a>
                </li>
              </ng-container>
              <li class="nav-item" [routerLinkActive]="['active']" routerLink="/contact-us" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="nav-link">Contact Us</a>
              </li>
              <li class="nav-item" [routerLinkActive]="['active']" routerLink="/faqs" data-bs-toggle="collapse" data-bs-target=".navbar-collapse.show">
                <a class="nav-link">FAQs</a>
              </li>
            </ng-container>


          </ul>
        </div>
      </div>

    </nav>
  </div>


</div>
<div class="row">
  <router-outlet></router-outlet>
</div>

<ngx-spinner name="default" type="ball-scale-multiple"></ngx-spinner>
<ngx-spinner name="auth" type="ball-scale-multiple">
  <h1 class="text-light opacity-75 fs-5">Authenticating...</h1>
</ngx-spinner>
